import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "../DroneSection/DroneSection.css";

import SmallDrone from "../../../assets/images/SmallDrone.png";
import Package from "../../../assets/images/Package1.png";
// import Pod from "../../../assets/images/Pod.png";
import Pod from "../../../assets/images/New_Pod.png";
// import Building from "../../../assets/images/Building.svg";
import NewBuilding from "../../../assets/images/NEWSVGBUILDING.svg";
import drone from "../../../assets/images/New_Drone.png";
const DroneSection = () => {
  const { scrollYProgress } = useScroll();

  const dropY = useTransform(scrollYProgress, [0, 1], [-90, 1500]); // Smooth downward drop
  const lineHeight = useTransform(scrollYProgress, [0, 1], [-50, 1500]);

  const leftDoorX = useTransform(scrollYProgress, [0, 1], [0, -190]); // move left
  const rightDoorX = useTransform(scrollYProgress, [0, 1], [0, 190]); // move right

  const leftTextY = useTransform(scrollYProgress, [0.05, 0.15], [50, 0]);
  const leftTextOpacity = useTransform(scrollYProgress, [0.05, 0.15], [0, 1]);
  
  const rightTextY = useTransform(scrollYProgress, [0.1, 0.2], [50, 0]);
  const rightTextOpacity = useTransform(scrollYProgress, [0.1, 0.2], [0, 1]);
  
  return (
    <div className="drone-wrapper">
      <div className="sticky-section">
        <div className="drone">
          <img src={drone} alt="Drone" />
        </div>

        {/* Line connected to drone */}
        <motion.div className="line" style={{ height: lineHeight }} />

        {/* Package drops down along line */}
        <motion.div className="package" style={{ y: dropY }}>
          <img src={Package} alt="Package" />
        </motion.div>

        <div className="pod-container">
          <img src={Pod} alt="Pod" className="pod-img" />

          <motion.div className="left-door" style={{ x: leftDoorX }} />
          <motion.div className="right-door" style={{ x: rightDoorX }} />
        </div>

        <div>
          <img className="building-div" src={NewBuilding} alt="Building" />
        </div>
        <motion.div
          className="fade-text left capitalize-first-letter"
          style={{ y: leftTextY, opacity: leftTextOpacity }}
        >
          From Sky to the doorstep in a flash
        </motion.div>
        <motion.div
          className="fade-text right capitalize-first-letter"
          style={{ y: rightTextY, opacity: rightTextOpacity }}
        >
         This is how Skye Air is changing the delivery game.
        </motion.div>
      </div>

      {/* Scroll content to enable scroll animation */}
      <div style={{ height: "300vh" }}></div>
    </div>
  );
};

export default DroneSection;
